import { useMemo } from "react";
import { IndexTable } from "@shopify/polaris";

const FinvaldaDetails = ({ meta = {}, t }) => {
  const rows = useMemo(() => Object.entries(meta), [meta]);

  if (rows.length === 0) {
    return null;
  }

  return (
    <IndexTable
      resourceName={{
        singular: "customer",
        plural: "customers",
      }}
      itemCount={rows.length}
      headings={[{ title: t("title") }, { title: t("value") }]}
      selectable={false}
    >
      {rows.map(([key, value], index) => (
        <IndexTable.Row id={key} key={key} position={index}>
          <IndexTable.Cell>
            <div>{key}</div>
          </IndexTable.Cell>
          <IndexTable.Cell>
            <div>{value}</div>
          </IndexTable.Cell>
        </IndexTable.Row>
      ))}
    </IndexTable>
  );
};

export default FinvaldaDetails;
